import React from 'react';
import { ClipLoader as LoadingSpinner } from 'react-spinners';

const SpinnerLoader = ({ color }) => {
  return (
    <div className="clip-loader-container">
      <LoadingSpinner color={color} />
    </div>
  );
};

export default SpinnerLoader;
